import { buildModalRoute } from '@manager/modules/modals/routable/modal-routable-utils';
import { routeNames } from '@manager/router/route-names';
import type { RouteMetaConfig } from '@manager/types/router';
import type { RouteLocationNamedRaw } from 'vue-router';

export const routesLocationSettings: RouteMetaConfig[] = [
  {
    path: '/location-settings',
    name: routeNames.locationSettingsOverview,
    component: () =>
      import('@manager/modules/location/views/LocationListView.vue'),
    props: { isStorefront: true },
    meta: {
      requiresAuth: true,
      permission: 'location_storefronts.view',
    },
  },
  {
    path: '/location-settings/:id(\\d+)',
    name: routeNames.locationSettingsDetails,
    component: () => import('./views/LocationSettingsDetailView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'location_storefronts.view',
    },
    children: [
      buildModalRoute(
        {
          path: 'edit/general',
          name: routeNames.locationSettingsEditGeneral,
          meta: {
            requiresAuth: true,
            permission: 'location_storefronts.update',
          },
          component: () =>
            import('./views/LocationSettingsEditGeneralFormView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          path: 'edit/domain',
          name: routeNames.locationSettingsEditDomain,
          meta: {
            requiresAuth: true,
            permission: 'location_storefronts.update',
          },
          component: () => import('./views/LocationSettingsDomainEditView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          path: 'edit/billing',
          name: routeNames.locationSettingsEditBilling,
          meta: {
            requiresAuth: true,
            permission: 'location_storefronts.update',
          },
          component: () =>
            import('./views/LocationSettingsEditBillingFormView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          path: 'edit/categories',
          name: routeNames.locationSettingsEditCategories,
          meta: {
            requiresAuth: true,
            permission: 'location_storefronts.update',
          },
          component: () =>
            import('./views/LocationSettingsEditCategoriesFormView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          path: 'edit/appearance',
          name: routeNames.locationSettingsEditAppearance,
          meta: {
            requiresAuth: true,
            permission: 'location_storefronts.update',
          },
          component: () =>
            import('./views/LocationSettingsEditAppearanceFormView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          path: 'edit/consents',
          name: routeNames.locationSettingsEditConsents,
          meta: {
            requiresAuth: true,
            permission: 'location_storefronts.update',
          },
          component: () =>
            import('./views/LocationSettingsEditConsentsFormView.vue'),
        },
        { fullscreen: false, width: 'md' }
      ),
      buildModalRoute(
        {
          path: 'edit/customer-portal',
          name: routeNames.locationSettingsEditCustomerPortal,
          meta: {
            requiresAuth: true,
            permission: 'location_storefronts.update',
          },
          component: () =>
            import('./views/LocationSettingsEditCustomerPortalFormView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          path: 'edit/contact',
          name: routeNames.locationSettingsEditContact,
          meta: {
            requiresAuth: true,
            permission: 'location_storefronts.update',
          },
          component: () =>
            import('./views/LocationSettingsEditContactFormView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          path: 'edit/opening-self-storage',
          name: routeNames.locationSettingsEditFacilityOpeningHours,
          meta: {
            requiresAuth: true,
            permission: 'location_storefronts.update',
          },
          component: () =>
            import('./views/LocationSettingsEditOpeningSelfStorageFormView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          path: 'edit/opening-office',
          name: routeNames.locationSettingsEditOfficeOpeningHours,
          meta: {
            requiresAuth: true,
            permission: 'location_storefronts.update',
          },
          component: () =>
            import('./views/LocationSettingsEditOpeningOfficeFormView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          path: 'edit/marketing',
          name: routeNames.locationSettingsEditMarketing,
          meta: {
            requiresAuth: true,
            permission: 'location_storefronts.update',
          },
          component: () =>
            import('./views/LocationSettingsEditMarketingFormView.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          path: 'edit/integrations',
          name: routeNames.locationSettingsEditIntegrations,
          meta: {
            requiresAuth: true,
            permission: 'location_storefronts.update',
          },
          component: () =>
            import('./views/LocationSettingsIntegrationsEditView.vue'),
        },
        { fullscreen: false }
      ),
    ],
  },
];

export const locationSettingsRoutesFactory = {
  editCustomerPortal(locationId: number | string): RouteLocationNamedRaw {
    return {
      name: routeNames.locationSettingsEditCustomerPortal,
      params: {
        id: locationId,
      },
    };
  },
};
